import { LOCAL_STORAGE_KEYS } from 'src/constants';
import { Action } from 'src/types/action';
import { Vendor, initialVendor } from 'src/types/vendor';
import { Logger } from 'src/utils/logger';

export const restoreVendor = (): Vendor | null => {
  let v = null;
  try {
    const storedData: string | null = window.localStorage.getItem(LOCAL_STORAGE_KEYS.SelectedVendor);

    if (storedData) {
      v = JSON.parse(storedData);
    } else {
      v = initialVendor;
    }
  } catch (err) {
    Logger.error(err);
    // If stored data is not a strigified JSON this will fail,
    // that's why we catch the error
  }

  return v;
};

export const storeVendor = (vendor: Vendor): void => {
  window.localStorage.setItem(LOCAL_STORAGE_KEYS.SelectedVendor, JSON.stringify(vendor));
};

export const vendorReducer = (state: Vendor, action: Action): Vendor => {
  switch (action.type) {
    case 'SetVendor':
      const v: Vendor = action.payload;
      if (v.boothsDropdown?.length === 1) {
        v.selectedBoothId = v.boothsDropdown[0].boothId;
        v.hasPrograms = v.hasPrograms;
      }
      return v;
    default:
      return state;
  }
};
